export default __webpack_public_path__ + "static/media/tpaita5.b1b4177c.jpg";